export const SAVE_CUBOID = "box/SAVE_CUBOID";
export const SAVE_CUBOID_SUCCESS = "box/SAVE_CUBOID_SUCCESS";
export const SAVE_CUBOID_ERROR = "box/SAVE_CUBOID_ERROR";

export const UPDATE_CUBOID = "box/UPDATE_CUBOID";
export const UPDATE_CUBOID_SUCCESS = "box/UPDATE_CUBOID_SUCCESS";
export const UPDATE_CUBOID_ERROR = "box/UPDATE_CUBOID_ERROR";
